'use client';

import { type FC } from 'react';

import { EmptyState } from '@yanolja-rnd/nol-design-system';
import { IcFailoverH72 } from '@yanolja-rnd/nol-icons';

interface ErrorFallbackProps {
  refetch: () => void;
}

export const ErrorFallback: FC<ErrorFallbackProps> = ({ refetch }) => {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <EmptyState
        icon={IcFailoverH72}
        title="네트워크 연결 상태가 좋지 않아요"
        description="연결 상태를 확인하고, 다시 시도해 주세요."
        buttons={[
          {
            content: '다시 시도하기',
            onClick: refetch,
          },
        ]}
      />
    </div>
  );
};
